import { escapeHtml, isNonNullableObject, typeCheck } from "@knyt/artisan";
import { stringToTemplateStringsArray } from "./stringToTemplateStringsArray.js";
import { isUnescapedString } from "./UnescapedString.js";
export function isStringDocumentFragment(value) {
    return (isNonNullableObject(value) &&
        "__isStringDocumentFragment" in value &&
        value.__isStringDocumentFragment === true);
}
export function createStringDocumentFragment(markup, values) {
    return {
        __isStringDocumentFragment: true,
        markup,
        values,
    };
}
(function (createStringDocumentFragment) {
    function fromString(markup) {
        return createStringDocumentFragment(stringToTemplateStringsArray(markup), []);
    }
    createStringDocumentFragment.fromString = fromString;
})(createStringDocumentFragment || (createStringDocumentFragment = {}));
function isStringValue(value) {
    return typeof value === "string" || isUnescapedString(value);
}
export function containsOnlyStrings(input) {
    const { markup, values } = input;
    if (markup.length !== values.length + 1) {
        return false;
    }
    for (const value of values) {
        if (!isStringValue(value)) {
            return false;
        }
    }
    return true;
}
export function renderStringsOnlyFragment({ markup, values, }) {
    let html = "";
    for (let i = 0; i < markup.length; i++) {
        html += markup[i];
        if (i < values.length) {
            const value = values[i];
            if (isUnescapedString(value)) {
                html += String(value);
            }
            else if (typeof value === "string") {
                html += escapeHtml(value);
            }
            else {
                // TODO: Remove in production
                typeCheck(typeCheck.identify(value));
                throw new TypeError(`Expected a string or UnescapedString, but got: ${typeof value}`);
            }
        }
    }
    return html;
}
